import React, { useContext } from "react"
import "twin.macro"
import { useEffectAsync } from "../../utils/hooks/useEffectAsync"
import { setLoginCookie } from "../../utils/cookie"
import { AuthContext } from "../../utils/context"
import { useLoginFacebookUserMutation } from "../../graphql/generated/graphql"
import { useRouter } from "next/router"
import { Routes } from "../../routes"
import { ReactComponent as OhNo } from "../../assets/errorPages/oopsy.svg"
import { useTranslation } from "next-i18next"

export const LoginExpired = () => {
  const { t } = useTranslation("facebook")
  return (
    <div tw="flex flex-col items-center text-center py-12 px-5 w-full m-auto space-y-5 tablet-lg:(py-28 w-[496px])">
      <OhNo />
      <p tw="font-bold text-[20px]">{t("error.cant_create")}</p>
      <p>{t("error.expired")}</p>
      <FacebookLogin />
    </div>
  )
}
declare global {
  interface Window {
    FB: any
  }
}
export const FacebookLogin = () => {
  const router = useRouter()
  const isFacebookSettings = router.pathname === Routes.FacebookSettings
  const [loginFacebookUser] = useLoginFacebookUserMutation()
  const { setUserId, setToken } = useContext(AuthContext)

  const handleOnBoarding = async (authResponse: Record<string, any>) => {
    const { accessToken, userID } = authResponse
    const { data } = await loginFacebookUser({
      variables: { facebookAccessToken: accessToken, facebookUserId: userID },
    })
    if (data?.LoginFacebookUser.token) {
      const { token, userId, username } = data.LoginFacebookUser
      setLoginCookie(token)
      setToken(token)
      userId && setUserId(userId)
      !isFacebookSettings && (await router.push({ pathname: Routes.Profile, query: { username } }))
    }
  }

  const initFacebookSdk = () => {
    window.FB.init({
      appId: "278674957995558", // TODO move app ID to env
      cookie: true,
      xfbml: true,
      version: "v19.0",
      status: true,
    })
  }

  const getFacebookLoginStatus = async () => {
    window.FB.getLoginStatus(async (response: Record<string, any>) => {
      if (response.authResponse) {
        console.log("Facebook logged in status:", response)
        return handleOnBoarding(response.authResponse)
      } else {
        console.log("No login status for the person")
        window.FB.login(
          (response: Record<string, any>) => {
            console.log("Facebook login status:", response)
            return handleOnBoarding(response.authResponse)
          },
          {
            config_id: "1473781696545038",
          },
        )
      }
    })
  }

  useEffectAsync(async () => {
    initFacebookSdk()
    // window.FB.logout()
  }, [])

  return (
    <div tw="relative" data-testid="facebook-login">
      <div
        className="fb-login-button"
        data-max-rows="1"
        data-size="large"
        data-width="260"
        data-use-continue-as="true"
      />
      <button tw="absolute top-0 left-0 w-full h-[40px] cursor-pointer" onClick={getFacebookLoginStatus} />
    </div>
  )
}
